import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../services/api.service';
import { FirmSharedService } from '../../firm/firmshared.service';

@Component({
  selector: 'engagement-preview',
  templateUrl: './engagement-preview.component.html',
  styleUrls: ['./engagement-preview.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DatePipe],
  standalone: false
})
export class EngagementPreviewComponent implements OnInit {
  engagementDetailsForm: UntypedFormGroup;
  Data: any = [];
  contentArray: any = [];
  editorContent;
  editorHeader;
  headerData: any = [];
  signatures;
  selectedSignature;
  islock: boolean;
  showEditor: boolean = true;
  editId;
  displayContent;
  firmuseracctid;
  loggedInUserData;
  totallength: any = 0;
  viewArray: any = [];
  contentViewArray: any = [];
  templateViewArray = [{
    "Content": [],
    "signatures":""
     }];
  //tempFinalArray: any = [];
  sideTemplateArray: any = [];
  newSection;
  selectedTemplate;
  createdDate;
  templateName;
  editTempName: boolean = false;
  NewSection: boolean = false;
  showCover: boolean = false;
  showContent: boolean = true;
  totalEngagementLetters;
  templateUrl;
  standardTemplate;
  blankTemplate;
  coverLetterArray: any = [];
  coverContent;
  templateType;
  logosData: any = [];
  coverEditor: any = "";
  coverHeaderArray: any = [];
  contentHeaderArray: any = [];
  selectedLogo;
  headerAddress;
  headerImage;
  FirmTemplateID;
  NB_BY_PAGE = 5000;
  headerImageUrl;
  headerEditor: boolean = false;
  coverHeaderEditor: boolean = false;
  headerContent;
  coverHeader;
  headersData;
  footersData;
  signaturesData;
  footerEditor: boolean = false;
  coverFooterEditor: boolean = false;
  coverFooter;
  contentFooterEditor: boolean = false;
  contentFooter;
  signHeaderEditor: boolean = false;
  signHeader: any = "Yours Faithfully";
  signatureSrc;
  signatureName;
  signatureDesignation;
  engagementClientId;
  engagementId;
  loginId;
  engagementTemplateId;
  selectedEngagementTemplate;
  config: any = {
    height: 250,
    theme: 'modern',
    // powerpaste advcode toc tinymcespellchecker a11ychecker mediaembed linkchecker help
    plugins: 'print preview searchreplace autolink directionality visualblocks visualchars fullscreen image imagetools link media template codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists textcolor wordcount contextmenu colorpicker textpattern',
    toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent fontselect fontsizeselect | removeformat',
    image_advtab: true,
    imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
    menubar: true,
    statusbar: false,
    images_upload_handler: (blobInfo, success, failure) => {
      let firmuseracctid;
      let loggedInUserData = JSON.parse((localStorage.getItem('userDetails')));
      if (loggedInUserData && loggedInUserData.useracctid) {
        firmuseracctid = loggedInUserData.useracctid
        this.bucketName=this.loggedInUserData.s3BucketName
      }
      var formData;
      formData = new FormData();
      let s3signatureKey = 'Engagements/' + firmuseracctid + '_Firm/Templates/Common/TemplateHeaders';
      let headerImageName = blobInfo.filename();
      let status: any = 0;
      formData.append('status', status);
      formData.append('signatureKey', s3signatureKey);
      formData.append("file", blobInfo.blob(), blobInfo.filename());

      this.uploadFile(formData).subscribe(response => {
        if (response) {
          this.headerImageUrl = 'https://s3.amazonaws.com/' + this.bucketName + '/' + s3signatureKey + '/' + headerImageName;
          success(this.headerImageUrl);
        }
      });
    },
    content_css: [
      '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
      '//www.tinymce.com/css/codepen.min.css'
    ]
  };
    dialogRef: MatDialogRef<any, any>;
  bucketName: any;

  constructor(public dialog: MatDialog, private _activatedRoute: ActivatedRoute,
    public firmService: FirmSharedService, private apiService: ApiService,
    private router: Router, private datePipe: DatePipe, private http: HttpClient, private fb: UntypedFormBuilder,
   private toastr: ToastrService) {

    //to reload component based on queryparam change from template dashboard component
    _activatedRoute.queryParams.subscribe(
      params => this.ngOnInit());

  }
  private uploadFile( formData: any) {
    var self = this;
    var headers = new HttpHeaders();
    return this.apiService.saveProfileImageToS3(formData);
  }
  ngOnInit() {
    this.loggedInUserData = JSON.parse((localStorage.getItem('userDetails')));
    this.bucketName=this.loggedInUserData.s3BucketName
    if (this.loggedInUserData && this.loggedInUserData.useracctid) {
      this.loginId = this.loggedInUserData.useracctid

    }
    this.engagementClientId = localStorage.getItem('engagementClientID');
    this.engagementId = localStorage.getItem('engagementID');

    this.engagementDetailsForm = this.fb.group({
      'templateName': new UntypedFormControl("", [Validators.required])
    });
    this.templateUrl = "";

    this.selectedTemplate = JSON.parse((sessionStorage.getItem('selectedTemplate')));
    this.selectedEngagementTemplate = JSON.parse((sessionStorage.getItem('engagementLetter')));
    this.engagementTemplateId = JSON.parse((sessionStorage.getItem('EngagementTemplateId')));

    if (this.selectedTemplate) {
      this.getJSON();
    }

  }
  getJSON() {
    if (this.selectedEngagementTemplate) {
      this.templateUrl = this.selectedEngagementTemplate[0].jsonfilepath;
      this.templateName = this.selectedEngagementTemplate[0].templatename;
    } else {
      this.templateUrl = this.selectedTemplate.JsonFilePath;
      this.templateName = this.selectedTemplate.TemplateName;
    }
    this.FirmTemplateID = this.selectedTemplate.FirmTemplateID;
    this.apiService.getFinancialDocumentDetailsFromJSON(this.templateUrl).subscribe(response => {

      this.Data = response[0];
      this.firmService.finalArray[0] = response[0];
      //this.createdDate = this.Data.createdDate;
      //this.templateName = this.Data.engagementLetterName;
      this.contentArray = this.Data.content;
      this.coverLetterArray = this.Data.coverLetter;
      this.headerContent = this.Data.contentHeaderData
      this.coverHeader = this.Data.coverHeaderData;
      this.contentFooter = this.Data.contentFooterData;
      this.coverFooter = this.Data.coverFooterData;
      this.signHeader = this.Data.signHeader;
      this.signatureName = this.Data.signatureName;
      this.signatureDesignation = this.Data.signatureDesignation;
      this.signatureSrc = this.Data.signatureSrc;
      this.sideTemplateArray = this.contentArray;
      if (this.Data.signatures.length > 0 ) {
          this.selectedSignature = this.Data.signatures[0];
      }

      this.createPageNos();
    }, error => {
        this.contentArray = [];

      })
  }
  showCoverLetter() {
    this.showCover = true;
    this.showContent = false;
    this.coverEditor = "";

  }
  showContents() {
    this.showContent = true;
    this.showCover = false;
  }
  createPageNos() {
    var newPageContentLength = 0;
    var pageNo = 1;
    var pageObj = {
      page: `page${pageNo}`,
      data: []
    };
    let temp = [];
    this.contentViewArray=[]
    this.contentArray.map(function (item) {
      if (item.checked) {
        temp.push(item);
      }
    })
    temp.forEach((item, i) => {
      [pageObj, newPageContentLength, pageNo] = this.cutInPages(item, pageObj, newPageContentLength, pageNo);
      if (i == temp.length - 1) {
        this.contentViewArray.push({ ...pageObj });
      }
    });
    this.templateViewArray[0].Content = this.contentViewArray;
  }

  private cutInPages(item, pageObj, newPageContentLength, pageNo) {
    let numberNeededToCompleteCurrentPage = this.NB_BY_PAGE - newPageContentLength;
    if (item.content.length <= numberNeededToCompleteCurrentPage) {
      pageObj.data.push({ ...item, checked: true });
      newPageContentLength += item.content.length;
      return [pageObj, newPageContentLength, pageNo]
    } else {
      let firstPartItem = { id: item.id, header: item.header, EditableMode: item.EditableMode, content: item.content.substr(0, numberNeededToCompleteCurrentPage), checked: true };
      pageObj.data.push({ ...firstPartItem, checked: true });
      this.contentViewArray.push({ ...pageObj });
      pageNo += 1;
      pageObj = {
        page: `page${pageNo}`,
        data: []
      };
      newPageContentLength = 0
      let secundPartItem = {
        id: item.id,
        content: item.content.substr(numberNeededToCompleteCurrentPage, item.content.length), checked: true
      };
      return this.cutInPages(secundPartItem, pageObj, newPageContentLength, pageNo);
    }
  }
  selectTemplate() {

    this.router.navigateByUrl('/dashboard/ntrdashboard/ClientOnboarding/EngagementDetails')
  }

  viewVisibility() {

    this.createPageNos();
  }
}
